import ApiService from './api.service'

const SearchService = {
  global (search = '') {
    return ApiService.get('api/v1/admin/search/global?search=' + search)
  }
}

export default SearchService
